import { Mail } from "lucide-react";

export const EMPTY_EMAIL = { to_kind: "client", team_id: null, address: "", subject: "", body: "" };

const FIELDS = [
  ["address", "Property address"], ["client", "Client name"], ["client_first", "Client first name"],
  ["product", "Product(s)"], ["due_date", "Due date"], ["photographer", "Photographer"],
  ["shoot_time", "Shoot date & time"], ["company", "Your company"],
];

const TO = [["client", "The property's client"], ["photographer", "The shoot's photographer"], ["team", "A team member"], ["address", "Email address(es)"]];

const inputCls = "h-9 w-full rounded-md border border-border bg-background px-3 text-sm";

export const AutomationEmailForm = ({ value, onChange, team = [] }) => {
  const set = (k) => (e) => onChange({ ...value, [k]: e.target.value });
  const insert = (f) => onChange({ ...value, body: `${value.body}${value.body && !value.body.endsWith(" ") ? " " : ""}{${f}}` });
  return (
    <div className="space-y-3 rounded-lg border border-primary/40 bg-primary/5 p-4" data-testid="automation-email-form">
      <div className="flex items-center gap-2 text-sm font-semibold"><Mail className="h-4 w-4 text-primary" /> Email to send</div>
      <label className="block text-xs text-muted-foreground">To
        <select value={value.to_kind} onChange={set("to_kind")} className={`${inputCls} mt-1`} data-testid="automation-email-to-kind">
          {TO.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
        </select>
      </label>
      {value.to_kind === "team" && (
        <select value={value.team_id || ""} onChange={set("team_id")} className={inputCls} data-testid="automation-email-team">
          <option value="">Pick a team member…</option>
          {team.map((t) => <option key={t.id} value={t.id} disabled={!t.email}>{t.name}{t.email ? "" : " (no email)"}</option>)}
        </select>
      )}
      {value.to_kind === "address" && (
        <input value={value.address || ""} onChange={set("address")} placeholder="name@example.com, other@example.com"
          className={inputCls} data-testid="automation-email-address" />
      )}
      <label className="block text-xs text-muted-foreground">Subject
        <input value={value.subject} onChange={set("subject")} placeholder="Your photos for {address} are on the way"
          className={`${inputCls} mt-1`} data-testid="automation-email-subject" />
      </label>
      <label className="block text-xs text-muted-foreground">Message
        <textarea value={value.body} onChange={set("body")} rows={7}
          placeholder={"Hi {client_first},\n\nThanks for booking {product} at {address}. ..."}
          className="mt-1 w-full rounded-md border border-border bg-background p-3 text-sm" data-testid="automation-email-body" />
      </label>
      <div className="flex flex-wrap gap-1.5">
        <span className="py-1 text-[11px] text-muted-foreground">Insert:</span>
        {FIELDS.map(([f, l]) => (
          <button key={f} type="button" onClick={() => insert(f)} data-testid={`automation-email-field-${f}`}
            className="rounded-full border border-border px-2.5 py-1 text-[11px] text-muted-foreground transition-colors hover:bg-secondary hover:text-foreground">{l}</button>
        ))}
      </div>
      <p className="text-[11px] text-muted-foreground">One email is sent per matching property each time the automation runs, and each one shows in Today's activity.</p>
    </div>
  );
};
